var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 6.6665H4.74058H21.3332",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85183 6.6665V4.6665C7.85183 4.13607 8.07035 3.62736 8.45932 3.25229C8.84828 2.87722 9.37583 2.6665 9.92591 2.6665H14.0741C14.6241 2.6665 15.1517 2.87722 15.5406 3.25229C15.9296 3.62736 16.1481 4.13607 16.1481 4.6665V6.6665M19.2592 6.6665V20.6665C19.2592 21.1969 19.0407 21.7056 18.6518 22.0807C18.2628 22.4558 17.7352 22.6665 17.1852 22.6665H6.8148C6.26472 22.6665 5.73717 22.4558 5.3482 22.0807C4.95924 21.7056 4.74072 21.1969 4.74072 20.6665V6.6665H19.2592Z",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.92578 11.6665V17.6665",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0742 11.6665V17.6665",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.56fe3d2a2f73ca9c17dffe887ffed25a.svg";
export { ForwardRef as ReactComponent };